// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1827":"NewsPage","2261":"RelatedContent","4794":"NewsListingPage"}[chunkId] + "_" + {"1827":"e572109cd7795dceea5f","2261":"e572109cd7795dceea5f","4794":"13841310e70043d3672e"}[chunkId] + ".css";
};